import { render } from "./QwCollapse.vue?vue&type=template&id=b2d01cb4"
import script from "./QwCollapse.vue?vue&type=script&lang=js"
export * from "./QwCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__